<template>
	<div class="body">
		<div class="body-container">

			<div class="right-content">
				<div class="content-title" v-if="title">
					<img class="title-wing" src="../../assets/icons/title_wing_left.png" />
					<span class="title-text">{{title}}</span>
					<img class="title-wing" src="../../assets/icons/title_wing_right.png" />
				</div>

				<div class="match-ctr">
					<div class="login-ctr" v-if="hasLogin == 2">
						<div class="login-tips">该功能需要登录后才能使用</div>
						<el-button class="to-login" type="primary" icon="el-icon-s-custom"
							@click="clickLogin">点击登录</el-button>
					</div>
					<template v-else-if="hasLogin == 1">

						<!-- <div class="waiting-tips">即将上线，敬请期待！</div> -->
						<div class="match-create-ctr">
							<el-button type="primary" icon="el-icon-plus" size="medium"
								@click="createUserMatch()">新建</el-button>
						</div>
						<el-table border :data="dataList">
							<el-table-column label="学校名称" align="center" prop="province_name" min-width="2">
								<template v-slot="{ row }">
									<label>{{row.college.name}}</label>
								</template>
							</el-table-column>
							<el-table-column label="专业层次" align="center" prop="level" min-width="1" />
							<el-table-column label="省直辖市" align="center" prop="provinceNames" min-width="1" />
							<el-table-column label="专业群名" align="center" prop="group_name" min-width="1" />
							<el-table-column label="专业" align="center" prop="majorNames" min-width="3" />
							<el-table-column label="平台岗位数量" align="center" prop="pmJobNum" min-width="1" />
							<el-table-column label="用户岗位数量" align="center" prop="userJobNum" min-width="1" />
							<el-table-column label="状态" align="center" prop="stateName" min-width="1" />
							<el-table-column label="创建日期" align="center" prop="created_at" min-width="2" />
							<el-table-column label="操作" align="center" prop="province_name" min-width="4">
								<template v-slot="{ row }">

									<el-button v-if="row.state == 2 || row.state == 3" type="primary"
										icon="el-icon-reading" size="small" class="el-button--success"
										@click="clickMatch(row)">查看</el-button>
									<el-button v-else type="primary" icon="el-icon-reading" size="small"
										class="el-button--warning" @click="clickMatch(row)">分析</el-button>

									<el-button type="primary" icon="el-icon-delete" size="small"
										class="el-button--danger" @click="clickDel(row)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>

					</template>


				</div>


			</div>
		</div>

		<el-dialog :visible.sync="showMatchDialog" title="新建岗位能力分析报告" align='center'>
			<div class="create-group-ctr">

				<div class="group-row" v-if="college">
					<label>院校名称</label>

					<el-input disabled class="group-input" :value="college.name" />
				</div>
				<div class="group-row" v-else>
					<label>院校名称</label>
					<el-select v-model="college_id" placeholder="请输入院校名称" class="select-width" filterable remote
						reserve-keyword :remote-method="loadCollegeList" :clearable=true>
						<el-option v-for="item in collegeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</div>

				<div class="group-row">
					<label>专业层次</label>
					<el-select v-model="level" placeholder="请选择专业的层次" class="group-select" filterable
						@change="onLevelChange">
						<el-option v-for="item in levelList" :key="item.name" :label="item.name + '专业'" :value="item.name">
						</el-option>
					</el-select>
				</div>

				<div class="group-row">
					<label>专业群名称</label>

					<el-input v-model="groupName" class="group-input" placeholder="请输入专业群名称" />
				</div>

				<div class="group-row">
					<label>专业</label>
					<el-select class="group-select" v-model="majors" placeholder="请选择" :clearable=true filterable
						multiple>
						<el-option v-for="item in majorList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
					<span>最多选6个</span>
				</div>

				<div class="group-row">
					<label>省直辖市</label>
					<el-select class="group-select" v-model="provinces" placeholder="请选择" :clearable=true filterable
						multiple :multiple-limit="3">
						<el-option v-for="item in provinceList" :key="item.value" :label="item.name"
							:value="item.value">
						</el-option>
					</el-select>
					<span>最多选3个</span>
				</div>

				<div class="group-row">
					<label>校企合作岗位(可选)</label>
					<el-upload ref="excelUpload" class="group-input" action="#" :auto-upload="false" :limit="1"
						accept=".xlsx" :on-change="handleExcelChange" :on-remove="handleExcelRemove"
						:on-exceed="handleExcelExceed" :file-list="excelFileList">
						<el-button size="small" type="primary" class="group-input upload-btn">选择文件</el-button>
					</el-upload>
					<a :href="excelTpl" target="_blank" class="el-button--success download-tpl">下载模板</a>
				</div>
				<div slot="tip" class="el-upload__tip">
					只能上传 .xlsx 文件，且不超过 10MB
				</div>

			</div>

			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="confirmCreateMatch()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAbilityConfig,
		getAbilityPageData,
		createJobAbilityReport,
		deleteAbilityReport
	} from "@/api/report"

	import {
		queryAllCollege,
		getMajorList
	} from "@/api/matrix"

	import {
		isEmpty,
		setLocalData,
		getLocalData
	} from "@/utils/util"

	import {
		useLoginStore
	} from "@/utils/login"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	export default {
		name: "Service",
		data() {
			return {
				name: '',
				provinces: [],
				majors: [],
				provinceList: [],
				showMatchDialog: false,
				dataList: [],
				collegeList: [],
				college: null,
				queryParams: {
					page: 1,
					pageSize: 20
				},
				title: '',
				level: '',
				hasLogin: 3,
				levelList: [],
				majorList: [],
				college_id: '',
				groupName: '',
				excelFile: null, // 当前选中的文件对象（原始 File）
				excelFileList: [], // el-upload 绑定的文件列表,
				excelTpl: ''
			}
		},

		setup() {
			const loginStore = useLoginStore()

			// 返回 store 到模板中使用
			return {
				loginStore
			}
		},

		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {
				this.requestMajorMatchList();
				this.loadConfig();
			},

			requestMajorMatchList() {
				getAbilityPageData(this.buildParams()).then(res => {
					this.hasLogin = res.data.hasLogin;
					if (this.hasLogin == 1) {
						this.dataList = res.data.list;
						this.total = res.data.pageData.totalCount;
					}
				});
			},

			loadConfig() {
				getAbilityConfig().then(res => {
					this.provinceList = res.data.provinceList;
					this.college = res.data.college;
					this.levelList = res.data.levelList;
					this.excelTpl = res.data.excelTpl
					this.title = res.data.title;
				});
			},


			loadCollegeList(name) {
				let params = {
					name: name
				}

				if (this.province) {
					params['province_code'] = this.province
				}

				if (this.city) {
					params['city_code'] = this.city
				}

				queryAllCollege(params).then(res => {
					this.collegeList = res.data.list;
				});
			},

			buildParams() {

				let provinces = this.provinces.join(',')
				let majors = this.majors.join(',')

				if (this.college) {
					this.queryParams['college_id'] = this.college['id'];
				} else {
					this.queryParams['college_id'] = this.college_id;
				}

				this.queryParams['level'] = this.level;
				this.queryParams['provinces'] = provinces;
				this.queryParams['majors'] = majors;
				this.queryParams['group_name'] = this.groupName;

				return this.queryParams;
			},


			onLevelChange(value) {
				this.majorList = [];
				this.majors = [];
				getMajorList({
					'degree': value,
					'from': 'report_ability'
				}).then(res => {
					this.majorList = res.data.majorList;
				})
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},

			clickCloseDialog() {
				this.showMaterialDialog = false;
			},

			//-----------match----------	

			createUserMatch() {
				this.showMatchDialog = true;
			},

			confirmCreateMatch() {

				// 组装 FormData
				const formData = new FormData()

				if (this.college) {

					formData.append('college_id', this.college['id'])
				} else {
					formData.append('college_id', this.college_id)
				}

				formData.append('level', this.level)
				formData.append('group_name', this.groupName)


				let provinces = this.provinces.join(',')
				let majors = this.majors.join(',')

				formData.append('majors', majors)
				formData.append('provinces', provinces)

				// 文件
				if (this.excelFile) {
					formData.append('file', this.excelFile)
				}

				createJobAbilityReport(formData).then(res => {
					this.showMatchDialog = false;
					this.requestMajorMatchList();
				})
			},

			clickMatch(row) {
				let path = '/ability_report?id=' + row.id;
				this.$router.push(path);
			},

			clickDel(row) {
				this.$modal.confirm('确定要删除该条数据吗？').then(() => {
					deleteAbilityReport({
						'id': row.id
					}).then(res => {
						this.requestMajorMatchList();
					})
				})
			},

			clickLogin() {
				this.loginStore.openLoginDialog()
			},

			/** 选择文件后触发（auto-upload=false 时不会真正上传） */
			handleExcelChange(file, fileList) {
				// el-upload 限制 limit=1，这里只保留最后一个
				this.excelFileList = fileList.slice(-1)
				this.excelFile = file.raw // 注意：原始文件在 file.raw

				// 额外做一次校验（accept 只是前端过滤，不可靠）
				const name = file.name || ''
				const isExcel = /\.(xlsx)$/i.test(name)
				const isLt10M = file.size / 1024 / 1024 < 10

				if (!isExcel) {
					this.$message.error('只能上传 .xlsx 文件')
					this.$refs.excelUpload.clearFiles()
					this.excelFile = null
					this.excelFileList = []
					return
				}
				if (!isLt10M) {
					this.$message.error('文件大小不能超过 10MB')
					this.$refs.excelUpload.clearFiles()
					this.excelFile = null
					this.excelFileList = []
					return
				}
			},

			/** 移除文件 */
			handleExcelRemove() {
				this.excelFile = null
				this.excelFileList = []
			},

			/** 超出数量限制时的提示 */
			handleExcelExceed() {
				this.$message.warning('只能上传一个 Excel 文件，请先移除已选文件')
			},

		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "ability_index.scss";
</style>